import React from "react";
import TableText from "../../TableText";

export const columns1 = ({ onChange, t_type }) => {
    return [{
        title: "",
        dataIndex: 'sort',
        key: 'sort',
        align: "center",
        width: 50,
        render: (text, record, index) => {
            const props = {
                text: text + 1, index, type: 'text', name: "sort", onChange,

            };
            return <TableText data={{ ...props }} />
        }
    }, {
        title: "榜单名称",
        dataIndex: 'name',
        key: 'name',
        align: "center",
        width: 300,
        render: (text, record, index) => {
            const props = {
                text, index, type: 'input', name: "name", onChange,
                compared: {
                    title: ['西餐厅', '榜单上榜情况'],
                    record: { ...record, name: '榜单名称' },
                    sqlName: "_5_9_2",
                    t_type
                }
            };
            return <TableText data={{ ...props }} />
        }
    }, {
        title: "榜单类型",
        dataIndex: 'type',
        key: 'type',
        align: "center",
        width: 100,
        render: (text, record, index) => {
            const props = {
                text, index, type: 'input', name: "type", onChange,
                compared: {
                    title: ['西餐厅', '榜单上榜情况'],
                    record: { ...record, name: '榜单类型' },
                    sqlName: "_5_9_2",
                    t_type
                }
            };
            return <TableText data={{ ...props }} />
        }
    }, {
        title: "评分",
        dataIndex: 'rate',
        key: 'rate',
        align: "center",
        width: 100,
        render: (text, record, index) => {
            const props = {
                text, index, type: 'inputNumber', name: "rate", onChange,
                compared: {
                    title: ['西餐厅', '榜单上榜情况'],
                    record: { ...record, name: '评分' },
                    sqlName: "_5_9_2",
                    t_type
                }
            };
            return <TableText data={{ ...props }} />
        }
    }, {
        title: "高于全城同品类%的商户",
        dataIndex: 'above',
        key: 'above',
        align: "center",
        width: 100,
        render: (text, record, index) => {
            const props = {
                text, index, type: 'inputPercent', name: "above", onChange,
                compared: {
                    title: ['西餐厅', '榜单上榜情况'],
                    record: { ...record, name: '高于全城同品类%的商户' },
                    sqlName: "_5_9_2",
                    t_type
                }
            };
            return <TableText data={{ ...props }} />
        }
    }, {
        title: "名次",
        dataIndex: 'rank',
        key: 'rank',
        align: "center",
        width: 100,
        render: (text, record, index) => {
            const props = {
                text, index, type: 'inputNumber', name: "rank", onChange,
                compared: {
                    title: ['西餐厅', '榜单上榜情况'],
                    record: { ...record, name: '名次' },
                    sqlName: "_5_9_2",
                    t_type
                }
            };
            return <TableText data={{ ...props }} />
        }
    }, {
        title: "备注",
        dataIndex: 'note',
        key: 'note',
        align: "center",
        width: 300,
        render: (text, record, index) => {
            const props = { text, index, type: 'input', name: "note", onChange };
            return <TableText data={{ ...props }} />
        }
    }];
}


export const columns2 = ({ onChange, t_type }) => {
    return [{
        title: "",
        dataIndex: 'sort',
        key: 'sort',
        align: "center",
        width: 50,
        render: (text, record, index) => {
            const props = { text: text + 1, index, type: 'text', name: "sort", onChange };
            return <TableText data={{ ...props }} />
        }
    }, {
        title: "名称",
        dataIndex: 'name',
        key: 'name',
        align: "center",
        width: 300,
        render: (text, record, index) => {
            const props = {
                text, index, type: 'input', name: "name", onChange,
                compared: {
                    title: ['西餐厅', '套餐情况'],
                    record: { ...record, name: '名次' },
                    sqlName: "_5_9_3",
                    t_type
                }
            };
            return <TableText data={{ ...props }} />
        }
    }, {
        title: "消费时间",
        dataIndex: 'time',
        key: 'time',
        align: "center",
        width: 150,
        render: (text, record, index) => {
            const props = {
                text, index, type: 'input', name: "time", onChange,
                compared: {
                    title: ['西餐厅', '套餐情况'],
                    record: { ...record, name: '消费时间' },
                    sqlName: "_5_9_3",
                    t_type
                }
            };
            return <TableText data={{ ...props }} />
        }
    }, {
        title: "价格",
        dataIndex: 'price',
        key: 'price',
        align: "center",
        width: 150,
        render: (text, record, index) => {
            const props = {
                text, index, type: 'inputNumber', name: "price", onChange,
                compared: {
                    title: ['西餐厅', '套餐情况'],
                    record: { ...record, name: '价格' },
                    sqlName: "_5_9_3",
                    t_type
                }
            };
            return <TableText data={{ ...props }} />
        }
    }, {
        title: "折扣",
        dataIndex: 'discount',
        key: 'discount',
        align: "center",
        width: 150,
        render: (text, record, index) => {
            const props = {
                text, index, type: 'inputPercent', name: "discount", onChange,
                compared: {
                    title: ['西餐厅', '套餐情况'],
                    record: { ...record, name: '折扣' },
                    sqlName: "_5_9_3",
                    t_type
                }
            };
            return <TableText data={{ ...props }} />
        }
    }, {
        title: "半年售",
        dataIndex: 'num',
        key: 'num',
        align: "center",
        width: 150,
        render: (text, record, index) => {
            const props = {
                text, index, type: 'inputNumber', name: "num", onChange,
                compared: {
                    title: ['西餐厅', '套餐情况'],
                    record: { ...record, name: '半年售' },
                    sqlName: "_5_9_3",
                    t_type
                }
            };
            return <TableText data={{ ...props }} />
        }
    }];
}


export const columns3 = ({ onChange, t_type }) => {
    return [{
        title: "",
        dataIndex: 'sort',
        key: 'sort',
        align: "center",
        width: 50,
        render: (text, record, index) => {
            const props = { text: text + 1, index, type: 'text', name: "sort", onChange };
            return <TableText data={{ ...props }} />
        }
    }, {
        title: "名称",
        dataIndex: 'name',
        key: 'name',
        align: "center",
        width: 300,
        render: (text, record, index) => {
            const props = {
                text, index, type: 'input', name: "name", onChange,
                compared: {
                    title: ['西餐厅', '推荐菜品 TOP3'],
                    record: { ...record, name: '名称' },
                    sqlName: "_5_9_4",
                    t_type
                }
            };
            return <TableText data={{ ...props }} />
        }
    }, {
        title: "价格（如有）",
        dataIndex: 'price',
        key: 'price',
        align: "center",
        width: 100,
        render: (text, record, index) => {
            const props = {
                text, index, type: 'inputNumber', name: "price", onChange,
                compared: {
                    title: ['西餐厅', `推荐菜品 No.${record.sort}`],
                    record: { ...record, name: '价格' },
                    sqlName: "_5_9_4",
                    t_type
                }
            };
            return <TableText data={{ ...props }} />
        }
    }];
}

export const data1 = [{
    sort: 0,
    name: "",
    type: "",
    rate: 0,
    above: 0,
    rank: 0,
    note: ""
}, {
    sort: 1,
    name: "",
    type: "",
    rate: 0,
    above: 0,
    rank: 0,
    note: ""
}, {
    sort: 2,
    name: "",
    type: "",
    rate: 0,
    above: 0,
    rank: 0,
    note: ""
}, {
    sort: 3,
    name: "",
    type: "",
    rate: 0,
    above: 0,
    rank: 0,
    note: ""
}, {
    sort: 4,
    name: "",
    type: "",
    rate: 0,
    above: 0,
    rank: 0,
    note: ""
}, {
    sort: 5,
    name: "",
    type: "",
    rate: 0,
    above: 0,
    rank: 0,
    note: ""
}, {
    sort: 6,
    name: "",
    type: "",
    rate: 0,
    above: 0,
    rank: 0,
    note: ""
}, {
    sort: 7,
    name: "",
    type: "",
    rate: 0,
    above: 0,
    rank: 0,
    note: ""
}];

export const data2 = [{
    sort: 0,
    name: "",
    time: "",
    price: 0,
    discount: 0,
    num: 0,
}, {
    sort: 1,
    name: "",
    time: "",
    price: 0,
    discount: 0,
    num: 0,
}, {
    sort: 2,
    name: "",
    time: "",
    price: 0,
    discount: 0,
    num: 0,
}, {
    sort: 3,
    name: "",
    time: "",
    price: 0,
    discount: 0,
    num: 0,
}, {
    sort: 4,
    name: "",
    time: "",
    price: 0,
    discount: 0,
    num: 0,
}, {
    sort: 5,
    name: "",
    time: "",
    price: 0,
    discount: 0,
    num: 0,
}, {
    sort: 6,
    name: "",
    time: "",
    price: 0,
    discount: 0,
    num: 0,
}, {
    sort: 7,
    name: "",
    time: "",
    price: 0,
    discount: 0,
    num: 0,
}];

export const data3 = [{
    sort: 0,
    name: "",
    price: 0,
}, {
    sort: 1,
    name: "",
    price: 0,
}, {
    sort: 2,
    name: "",
    price: 0,
}];

export const defaultData = {
    rate: 0,
    taste: "",
    environment: "",
    service: "",
    varieties: "",
    num: 0,
    price: 0
};


// WEBPACK FOOTER //
// ./src/components/table/5.0/5-9/data.js